<template>
	<div id="map" @x-keyup.esc="toggleMarkers()" @click.self="$router.push('/')" >
		<div class="parent-enfant-icon hidden" ref="parent-enfant-icon">
			<enfant-icon class="persos"/>
			<pointeur-icon class="pointeur"/>
			<pointeur-icon class="pointeur-shadow"/>
		</div>
	</div>
</template>

<script>

import L from 'leaflet';
import villeData from "@ville/data";
import etablissements from "@ville/places";
import EnfantIcon from './icons/enfants.svg';
import PointeurIcon from './icons/pointeur-seul.svg';
import { mapState } from 'vuex';

var assign = require('es6-object-assign').assign;

export default {
	name: 'Map',
	components : {
		EnfantIcon,
		PointeurIcon,
	},
	data() {

		return {
			bounds: {},
			delayDisplayWms: 1000,
			mapObject: false,
			markers: {},
			selectMaxZoom: 16,
			displayMarkers: true,
			selected: "",
			zoomLevel: 0,
			parentEnfantIcon: 0,
			regularIcons: {},
		};
	},
	created() {
		this.$store.watch(
			(state) => this.$store.getters.etablissement,
			(e) => {
				if (this.selected.length) {
					this.unselect(this.selected)
				}

				if (e.slug) {
					this.select(e.slug)
				}
			}
		);
	},
	methods: {
		// TODO: suppr en prod
		toggleMarkers() {
			if (this.displayMarkers) {
				this.markerPane.style.display = "none";
			}
			else {
				this.markerPane.style.display = "block";
			}
			this.displayMarkers = ! this.displayMarkers;

		},
		fitScreen() {
			this.mapObject.fitBounds(villeData.bounds)
		},
		unselect(slug) {
			const marker = this.markers[slug];

			if (!marker)
				return;

			marker.setIcon(this.regularIcons[marker.pollution]);
		},
		select(slug) {
			const marker = this.markers[slug];
			if (!marker)
				return;

			marker.setIcon(this.parentEnfantIcon);

			const latlng = marker.getLatLng();
			const zoom = Math.max(this.selectMaxZoom, this.mapObject.getZoom());


			this.mapObject.setView(latlng, zoom);
			let container_point = this.mapObject.latLngToContainerPoint(latlng)
			container_point.y += 70
			let new_latlng = this.mapObject.containerPointToLatLng(container_point)
			this.mapObject.setView(new_latlng);

			this.selected = slug;

		},
		zoomCommand(action) {
			switch (action) {
				case 'in':
					this.mapObject.zoomIn();
					break;

				case 'out':
					this.mapObject.zoomOut();
					break;
			}
		},
		pollutionLevel(e) {
			let p = e.n50;

			if (p) {
				if (p <= 10) return 1;
				if (p <= 30) return 2;
				if (p <= 40) return 3;
				return 4;
			}
		},
		createMap() {
			this.parentEnfantIcon = L.divIcon({
				className: "etablissement-icon selected",
				html:'<div class="parent-enfant-icon">'+this.$refs['parent-enfant-icon'].innerHTML+'</div>',
				iconAnchor: [26, 66]
			});

			for (let i = 1; i < 5; i++) {
				this.regularIcons[i] = L.divIcon({
					className: "etablissement-icon",
					html: '<div class="rond level-'+i+'"></div>',
					iconAnchor: [10, 10]
				})
			}


			this.mapObject = L.map('map', {
				zoomControl: false,
				minZoom: villeData.minZoom,
				maxZoom: villeData.maxZoom,
			}); // .fitBounds(L.latLngBounds(villeData.bounds));


	// voir aussi : 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png'
			let background = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png', {
				attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
				subdomains: 'abcd',
				minZoom: villeData.minZoom,
				maxZoom: villeData.maxZoom
			});

			let labels = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png', {
				attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
				subdomains: 'abcd',
				minZoom: villeData.minZoom,
				maxZoom: villeData.maxZoom
			});

			let wmsLayer = L.tileLayer
				.wms(
					villeData.wms.url,
					assign({},
						villeData.wms.params, {
							attribution: villeData.attribution,
							className: 'wms',
							transparent: true,
							opacity: 0,
							minZoom: villeData.minZoom,
							maxZoom: villeData.maxZoom
						}
					)
				)
				.on('load', (e) => {
					setTimeout(() => {
						// on ne passe pas par un ajout de la classe
						// dans le template, ça marche pô ... ;(
						// ça supprime les autres classes posées par Leaflet
						// Voir : https://github.com/vuejs/vue/issues/3975
						this.$el.classList.add('show-wms');
					}, this.delayDisplayWms);
				});

			background.addTo(this.mapObject);
			wmsLayer.addTo(this.mapObject);
			labels.addTo(this.mapObject);

			let bounds = L.latLngBounds();

			for (let i in etablissements) {
				const e = etablissements[i];
				let coords = [e.lat, e.lng];
				let level = this.pollutionLevel(e)
				let marker = new L.marker(coords, {
					icon: this.regularIcons[ level ],
					title: e.name
				}).addTo(this.mapObject);

				marker.slug = e.slug;
				marker.pollution = level;

				marker.on('click', (e) => {
					let slug = marker.slug;
					this.$router.push('/' + slug)
					this.$emit('select', slug);
				});

				this.markers[e.slug] = marker;
				bounds.extend(coords);
			}



			this.bounds = bounds;
			this.fitScreen();

			this.markerPane = this.mapObject.getPane('markerPane');

			this.mapObject.on('zoom', (e) => {
				this.$el.classList.remove('zoom-' + this.zoomLevel);
				this.zoomLevel = this.mapObject.getZoom();
				this.$el.classList.add('zoom-' + this.zoomLevel);
			})

			//this.mapObject.on('click', (e) => console.log(e.latlng))

			this.zoomLevel = this.mapObject.getZoom();
			this.$el.classList.add('zoom-' + this.zoomLevel);
		},
	},
	mounted() {
		this.createMap()
	}
}
</script>

<style lang="scss">

.wms {
	opacity: 0;
	transition: opacity 1s;

	.show-wms & {
		opacity: .75 !important;
	}
}
</style>

<style scoped lang="scss">
@import "~leaflet/dist/leaflet.css";

.map {
	position: relative;
	height: 100%;
}

.hidden {
	display: none;

}


</style>

<style lang="scss">

.etablissement-icon {
	width: 20px !important;
	height: 20px !important;

	.rond {
		border-radius: 50%;
		border: 1px solid $bg-box;
		//background-color: #00a0e1;
		transform-origin: 50% 50%;
		width: 100%;
		height: 100%;


		@for $i from 1 through length($levels) {
			&.level-#{$i} {
				background-color: nth($levels, $i);
			}
		}

		$map: .2, .2, .2, .2, .2, .2, .24, .28, .32, .36, .4, .44, .5, .56, .62, .7, .78, .9, .99, 1.8;

		@for $i from 1 through length($map) {
			.zoom-#{$i} & {
				$zoom: nth($map, $i);

				$border: round(2 / $zoom);
				@if ($border > 5) {
					$border: 5;
				}

				border-width: #{ $border }px;
				transform: scale($zoom);
			}
		}
	}

	&.selected {
		width: 32px !important;
		height: auto !important;
		background-color: transparent;
		border: none;
	}

	.parent-enfant-icon {
		position: relative;
		width: 50px;

		> * {
			position: absolute;
		}

		.persos {
			z-index: 20;
			transform: scale(.6);
			transform-origin: center;
			top: 6px;
			fill: #fff;
		}

		.pointeur {
			fill: $bg-box; // #00a0e1;
			//stroke-width: 2px;
			//stroke: #fff;
			//stroke-linejoin: round;
			z-index: 10;
		}

		.pointeur-shadow {
			fill: #666;
			stroke-width: 0;
			z-index: 9;
			transform: scaleY(0.3) rotate(29deg) skew(-20deg, 6deg);
			transform-origin: 24px 67px;
			opacity: .3;
		}
	}
}


.leaflet-tile-container img {
    box-shadow: 0 0 1px rgba(150, 150, 0, 0.05);
}
</style>
